/**
 * @class Oskari.mapframework.bundle.publisher2.event.MapPublishedEvent
 *
 * Used to notify components that a new published map is available.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher.event.MapPublishedEvent',
/**
 * @method create called automatically on construction
 * @static
 * @param {Number} mapId id for the new map
 * @param {Number} width width for the new map
 * @param {Number} height height for the new map
 * @param {String} language language for the map
 */
function (mapId, width, height, language, url) {
  this._id = mapId;
  this._width = width;
  this._height = height;
  this._language = language;
  this._url = url;
}, {
  /** @static @property __name event name */
  __name: 'Publisher.MapPublishedEvent',
  /**
   * @method getName
   * Returns event name
   * @return {String}
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method getUrl
   * Returns url for the published map
   * @return {String}
   */
  getUrl: function getUrl() {
    return this._url;
  },
  /**
   * @method getId
   * Returns id for the published map
   * @return {Number}
   */
  getId: function getId() {
    return this._id;
  },
  /**
   * @method getWidth
   * Returns width for the published map
   * @return {Number}
   */
  getWidth: function getWidth() {
    return this._width;
  },
  /**
   * @method getHeight
   * Returns height for the published map
   * @return {Number}
   */
  getHeight: function getHeight() {
    return this._height;
  },
  /**
   * @method getLanguage
   * Returns language code for the language the user selected for the map
   * @return {String}
   */
  getLanguage: function getLanguage() {
    return this._language;
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  'protocol': ['Oskari.mapframework.event.Event']
});